import { CommonModule } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { ToasterComponent } from '@lib/components/toaster/toaster.component';
import { IconService } from '@lib/services/material-icon-registry/icon.service';
import { ThemeService } from '@lib/services/theme';
import { selectAppSession } from '@lib/store';
import { storage } from '@lib/utils/storage/storage.utils';
import { Store } from '@ngrx/store';
import { filter, Subscription, take } from 'rxjs';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [CommonModule, RouterModule, ToasterComponent],
    template: `
        <link
            href="https://fonts.googleapis.com/icon?family=Material+Icons"
            rel="stylesheet"
        />
        <router-outlet></router-outlet>
        <app-toaster></app-toaster>
    `,
})
export class AppComponent implements OnInit, OnDestroy {
    private readonly _themeService = inject(ThemeService);
    private readonly _router = inject(Router);
    private readonly _store = inject(Store);
    private readonly _iconService = inject(IconService);
    private _routerSubscription: Subscription | null = null;
    private _unloadListener: (() => void) | null = null;

    ngOnInit(): void {
        this._themeService.init();
        this._setupScrollToTop();
        this._setupUnloadPersistence();
    }

    ngOnDestroy(): void {
        if (this._routerSubscription) {
            this._routerSubscription.unsubscribe();
        }
        if (this._unloadListener) {
            globalThis.removeEventListener('beforeunload', this._unloadListener);
        }
    }

    private _setupScrollToTop(): void {
        this._routerSubscription = this._router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe(() => {
                globalThis.scrollTo(0, 0);
            });
    }

    private _setupUnloadPersistence(): void {
        this._unloadListener = () => {
            this._store
                .select(selectAppSession)
                .pipe(take(1))
                .subscribe((session) => {
                    if (session) {
                        storage.setItem('appSession', session);
                    } else {
                        storage.removeItem('appSession');
                    }
                });
        };
        globalThis.addEventListener('beforeunload', this._unloadListener);
    }
}
